import { useState, useMemo, ReactNode, useRef } from 'react';
import AudioContext from './AudioContext';
import useMediaEnd from '../hooks/useMediaEnd';

interface AudioProviderProps {
  children: ReactNode;
};

function AudioProvider({ children }: AudioProviderProps) {
  const [audioSrc, setAudioSrc] = useState<string>('');
  const [isPlayed, setIsPlayed] = useState<boolean>(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const endAudio = useMediaEnd();

  const audioContextValues = useMemo(() => ({
    audioSrc,
    setAudioSrc,
    audioRef,
    isPlayed,
    setIsPlayed,
  }), [audioSrc, isPlayed]);
  
  return (
    <AudioContext.Provider value={ audioContextValues }>
      { children }
      <audio ref={audioRef} onEnded={endAudio} />
    </AudioContext.Provider>
  )
};

export default AudioProvider;